import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { QuotePreviewController } from "@/modules/quotes/QuotePreviewController";

/** Props for the ThreadQuoteSheet component. */
interface ThreadQuoteSheetProps {
  quoteId: string | null;
  onClose: () => void;
}

/**
 * Slide-over sheet that previews a quote referenced from a thread summary.
 * Open whenever a quoteId is provided; closing clears the selection.
 * @param props - The component props
 * @returns The quote preview sheet
 */
export function ThreadQuoteSheet({ quoteId, onClose }: ThreadQuoteSheetProps) {
  return (
    <Sheet
      open={quoteId !== null}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <SheetContent
        side="right"
        className="w-1/2 max-w-none overflow-y-auto p-0"
      >
        <SheetHeader className="border-b px-6 py-4">
          <SheetTitle>Quote</SheetTitle>
        </SheetHeader>
        {quoteId && (
          <div className="p-6">
            <QuotePreviewController
              key={quoteId}
              quoteId={quoteId}
              showActionButtons={false}
            />
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
